export const getAttachmentLabel = (file) => {
    return file?.originalName || file?.fileName || file?._id || 'Adjunto';
};

export const getAttachmentExtension = (file) => {
    const explicitExtension = String(file?.extension || '').trim().toLowerCase();
    if (explicitExtension) return explicitExtension;

    const name = String(file?.originalName || file?.fileName || '').trim().toLowerCase();
    if (!name.includes('.')) return '';

    const parts = name.split('.');
    return String(parts[parts.length - 1] || '').trim();
};

export const getAttachmentIconClass = (file) => {
    const extension = getAttachmentExtension(file);
    const mimeType = String(file?.mimeType || '').toLowerCase();

    if (mimeType.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg', 'heic'].includes(extension)) {
        return 'bi bi-file-earmark-image';
    }

    if (mimeType === 'application/pdf' || extension === 'pdf') {
        return 'bi bi-file-earmark-pdf';
    }

    if (
        mimeType.includes('sheet')
        || mimeType.includes('excel')
        || ['xls', 'xlsx', 'csv'].includes(extension)
    ) {
        return 'bi bi-file-earmark-spreadsheet';
    }

    if (
        mimeType.includes('word')
        || ['doc', 'docx', 'odt', 'rtf'].includes(extension)
    ) {
        return 'bi bi-file-earmark-word';
    }

    if (
        mimeType.includes('zip')
        || mimeType.includes('compressed')
        || ['zip', 'rar', '7z', 'tar', 'gz'].includes(extension)
    ) {
        return 'bi bi-file-earmark-zip';
    }

    if (
        mimeType.startsWith('video/')
        || ['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)
    ) {
        return 'bi bi-file-earmark-play';
    }

    if (
        mimeType.startsWith('audio/')
        || ['mp3', 'wav', 'aac', 'ogg'].includes(extension)
    ) {
        return 'bi bi-file-earmark-music';
    }

    if (
        mimeType.startsWith('text/')
        || ['txt', 'md', 'log'].includes(extension)
    ) {
        return 'bi bi-file-earmark-text';
    }

    return 'bi bi-file-earmark';
};

export const getAttachmentIconColorClass = (file) => {
    const extension = getAttachmentExtension(file);
    const mimeType = String(file?.mimeType || '').toLowerCase();

    if (mimeType.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg', 'heic'].includes(extension)) {
        return 'text-info';
    }

    if (mimeType === 'application/pdf' || extension === 'pdf') {
        return 'text-danger';
    }

    if (
        mimeType.includes('sheet')
        || mimeType.includes('excel')
        || ['xls', 'xlsx', 'csv'].includes(extension)
    ) {
        return 'text-success';
    }

    if (
        mimeType.includes('word')
        || ['doc', 'docx', 'odt', 'rtf'].includes(extension)
    ) {
        return 'text-primary';
    }

    if (
        mimeType.includes('zip')
        || mimeType.includes('compressed')
        || ['zip', 'rar', '7z', 'tar', 'gz'].includes(extension)
    ) {
        return 'text-warning';
    }

    if (
        mimeType.startsWith('video/')
        || ['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)
    ) {
        return 'text-primary';
    }

    if (
        mimeType.startsWith('audio/')
        || ['mp3', 'wav', 'aac', 'ogg'].includes(extension)
    ) {
        return 'text-secondary';
    }

    if (
        mimeType.startsWith('text/')
        || ['txt', 'md', 'log'].includes(extension)
    ) {
        return 'text-dark';
    }

    return 'text-muted';
};
